<template>
  <div>
    <v-container grid-list-lg>
      <v-layout row wrap style="justify-content: center">
        <v-flex md12 xs12>
          <v-list class="d-flex pa-2" style="background-color: #199995; color: white">
            <v-layout row wrap>
              <v-flex md5 xs5>
                <v-list-tile>
                <v-list-tile-action class="icon">
                  <img src="/static/person.png" height="16" />
                </v-list-tile-action>
                <v-list-tile-content class="listContent">
                  <small>{{patientName}}</small>
                  <small>{{patId}}</small>
                </v-list-tile-content>
                </v-list-tile>
              </v-flex>
              <v-flex md5 xs4>
                <v-list-tile>
                  <v-list-tile-action class="icon">
                    <img src="/static/event.png" height="20" />
                  </v-list-tile-action>
                  <v-list-tile-content class="listContent">
                    <small>{{examDate}}</small>
                  </v-list-tile-content>
                </v-list-tile>
              </v-flex>
              <v-flex md1 xs3>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-btn flat="" to="/login"><img class="logo" src="/static/logo_negativo.png" height="44" /></v-btn>
                  </v-list-tile-action>
                </v-list-tile>
               </v-flex>
            </v-layout>
          </v-list>
        </v-flex>
        <div v-if="data.status!='PUBLICADO' && listImageURL.length < 1 && listVideos.length < 1" style="width:100%">
          <v-card>
            <v-card-text class="text-xs-center py-5">
              <div class="headline">{{ $t('messages.noMediaFound') | capitalize }}</div>
            </v-card-text>
          </v-card>
        </div>
        <v-container v-if="data.status!='PUBLICADO'" fluid="fluid" style="padding:0%">
        </v-container>
        <v-flex v-else md9 xs12>
            <v-card class="pdfDocument">
              <vue-pdf-app :pdf="urlReport" @open="loaded = true"></vue-pdf-app>
            </v-card>
            <div class="loading">
              <v-progress-circular color="primary" indeterminate :size="80" v-show="loaded === false"></v-progress-circular>
            </div>
        </v-flex>
        <v-container v-if="listImageURL.length < 1 && listVideos.length < 1" fluid="fluid" style="padding:0%">
        </v-container>
        <v-flex v-else md3 xs12>
          <div style="margin-bottom: 8px">
            <v-layout row="row" wrap="wrap" style="justify-content: center">
              <v-flex md12 xs12>
                <v-card flat="flat" tile="tile">
                  <v-img :src="listImageURL[0]" @click="slideIndex = i" @load="imgLoaded=true" style="height: 100%; width: 100%; background-color: black;">
                  </v-img>
                </v-card>
              </v-flex>
              <vue-gallery :images="listImageURL" :index="slideIndex" @close="slideIndex = null"></vue-gallery>
              <v-label v-if="imgLoaded" class="ImageCount" style="background-color: lightgray">{{listImageURL.length}} Imagens</v-label>
            </v-layout>
          </div>
          <div>
            <v-flex v-for="(video, i) in listVideos" :key="i"  style="padding:0px" md12 x12>
              <v-card>
                <iframe
                :src="video"
                width="100%"
                height="200px"
                style="border: 0px"
                allowfullscreen="allowfullscreen"
                mozallowfullscreen="mozallowfullscreen"
                msallowfullscreen="msallowfullscreen"
                oallowfullscreen="oallowfullscreen"
                webkitallowfullscreen="webkitallowfullscreen"/>
              </v-card>
            </v-flex>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import 'vue-pdf-app/dist/icons/main.css'
import VuePdfApp from 'vue-pdf-app'
import moment from 'moment'
import VueGallery from 'vue-gallery'
import axios from 'axios'

const URL_BASE_REPORT = 'https://report-server-dev-dot-ultracarebr.rj.r.appspot.com/report/'

export default {
  name: 'PortalPaciente',
  components: {
    VuePdfApp,
    VueGallery
  },
  props: {
    id: {
      required: false
    }
  },
  computed: {
    urlReport () {
      return (URL_BASE_REPORT && this.id) ? (URL_BASE_REPORT + this.id) : ''
    },
    listVideos () {
      return this.data && this.data.videosList ? this.data.videosList : ''
    },
    patientName () {
      return this.data && this.data.patient && this.data.patient.patientName ? this.data.patient.patientName : ''
    },
    patId () {
      return this.data && this.data.patient && this.data.patient.patId ? this.data.patient.patId : ''
    },
    examDate () {
      return this.data && this.data.studyDate ? moment(this.data.studyDate).format('DD/MM/YYYY') : ''
    }
  },

  data () {
    return {
      data: [{}],
      listImageURL: [{}],
      loaded: false,
      imgLoaded: false,
      slideIndex: null
    }
  },
  async mounted () {
    await this.axiosGet()
  },

  methods: {
    axiosGet () {
      axios.get('https://us-central1-ultracarebr.cloudfunctions.net/patientPortal?id=' + this.id)
       .then(res => {
         this.data = res.data
         this.listImageURL = res.data.imagesList
       })
      .catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style scoped>
  small {
    font-size: 70%;
  }
  .icon{
    justify-content: center;
  }

  .listContent{
    overflow: visible!important;
  }

  .pdfDocument{
    height: 100%;
    min-height: 75vh;
    width: -webkit-fill-available;
    width: -moz-available;
    width: -o-available;
    width: intrinsic;
    width: 100%;
  }
   .loading {
    position: absolute;
    top: 50%;
    left: 40%;
    transform: translate(-50%, -50%);
  }

  @media all and (max-width: 800px) {
  .listContent {
    font-size: 70%;
  }
   .loading {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PatientPortal.vue